(function(window) {
    const bttEl = document.getElementById('btnBackToTop');

    if (!bttEl) return;

    function toggleVisible() {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300){
            bttEl.classList.add('active');
        }
        else if (scrolled <= 300){
            bttEl.classList.remove('active');
        }
    }

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    function init() {
        bttEl.addEventListener('click', (e) => {
            e.preventDefault();
            scrollToTop();
        })
        window.addEventListener('scroll', toggleVisible);
    }

    document.addEventListener('DOMContentLoaded', function() {
        init();
    });
})(window);
